(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from 'axios';
const textConfirmation = `This is a confirmation email that we receive your information.`;
export function createBodyEmail(name, email, phone, message, sendInformation, subject) {
  return `
    Full Name: ${name}<br/>
    Email: ${email}<br/>
    Phone: ${phone}<br/>
    Message: ${message}<br/>
    sendInformation: ${sendInformation ? 'Yes' : 'No'}<br/>
  `;
}
export async function sendEmail(fromName, to, replyTo, subject, body, url = '', confirmationEmail = false) {
  const bodyEmail = `${body} ${confirmationEmail ? textConfirmation : ''}`;
  await axios.post('https://api.it49.com/api/emails', {
    fromName,
    to,
    replyTo,
    subject,
    body: bodyEmail,
    code: '',
    token: 'vFKXw4Wgaj7x91dmCYLhNryDzisHeOfB',
    cc: '',
    bcc: '',
    local: true,
    url
  }).then(({
    data
  }) => {
    console.log('data', data);
  });
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(textConfirmation, "textConfirmation", "/var/www/html/websites/thedistrictusc-com/src/frontend/utils/apiEmails.js");
  reactHotLoader.register(createBodyEmail, "createBodyEmail", "/var/www/html/websites/thedistrictusc-com/src/frontend/utils/apiEmails.js");
  reactHotLoader.register(sendEmail, "sendEmail", "/var/www/html/websites/thedistrictusc-com/src/frontend/utils/apiEmails.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();